"use client";

import type { FC } from "react";

import { isEditing } from "@builder.io/sdk-react";

import { EventsLocator as UIEventsLocator } from "@des/locators/components/EventsLocator";

import type { eventsLocatorInputs } from "./EventsLocator.builder";

type EventsLocatorBuilderProps = BuilderComponentProps<typeof eventsLocatorInputs>;

const DEFAULT_ZOOM = 15;
const DEFAULT_STORES_LIMIT = 1000;

export const EventsLocator: FC<EventsLocatorBuilderProps> = ({
  defaultLatitude,
  defaultLongitude,
  storesLimit,
  defaultZoom,
}) => {
  return (
    <UIEventsLocator
      defaultLat={String(defaultLatitude)}
      defaultLng={String(defaultLongitude)}
      defaultZoom={defaultZoom || DEFAULT_ZOOM}
      storesLimit={storesLimit || DEFAULT_STORES_LIMIT}
      isInEditor={isEditing()}
    />
  );
};
